import {
  AIR_HELP,
  AIRPORT_TRANSFER,
  BAGGAGE_SERVICE,
  BANKRUPTCY_INSURANCE_COVER_GENIUS,
  CABIN_BAGGAGE,
  CANCEL_24_HOURS,
  CANCEL_FOR_ANY_REASON,
  CANCELLATION_GUARANTEE,
  CANCELLATION_INSIDE_EU,
  CANCELLATION_INSURANCE_COVER_GENIUS,
  CANCELLATION_OUTSIDE_EU,
  CHECK_IN_BAGGAGE,
  CLIMATE_COMPENSATION,
  COMPREHENSIVE_INSURANCE_COVER_GENIUS,
  FAST_TRACK,
  FLEXIBLE_TICKET,
  LOUNGE,
  LOUNGE_PER_SEGMENT,
  MEAL,
  CO2_COMPENSATION,
  MOBILE_TRAVEL_PLAN,
  ONLINE_CHECK_IN,
  SEAT_MAP,
  SECOND_BAGGAGE_PER_TRAVELER,
  SIMPLE_VISA,
  SMS,
  TRAVEL_INSURANCE_COVER_GENIUS,
  TRAVEL_INSURANCE_INSIDE_EU,
  TRAVEL_INSURANCE_OUTSIDE_EU,
  PLATINUM_SERVICE,
} from '@eti/products';

export const SUPPORTED_PRODUCTS = [
  AIR_HELP,
  AIRPORT_TRANSFER,
  BAGGAGE_SERVICE,
  BANKRUPTCY_INSURANCE_COVER_GENIUS,
  CABIN_BAGGAGE,
  CANCEL_24_HOURS,
  CANCEL_FOR_ANY_REASON,
  CANCELLATION_GUARANTEE,
  CANCELLATION_INSIDE_EU,
  CANCELLATION_INSURANCE_COVER_GENIUS,
  CANCELLATION_OUTSIDE_EU,
  CHECK_IN_BAGGAGE,
  CLIMATE_COMPENSATION,
  COMPREHENSIVE_INSURANCE_COVER_GENIUS,
  CO2_COMPENSATION,
  FLEXIBLE_TICKET,
  MEAL,
  MOBILE_TRAVEL_PLAN,
  ONLINE_CHECK_IN,
  SEAT_MAP,
  SECOND_BAGGAGE_PER_TRAVELER,
  SIMPLE_VISA,
  SMS,
  TRAVEL_INSURANCE_COVER_GENIUS,
  TRAVEL_INSURANCE_INSIDE_EU,
  TRAVEL_INSURANCE_OUTSIDE_EU,
  FAST_TRACK,
  PLATINUM_SERVICE,
  LOUNGE,
  LOUNGE_PER_SEGMENT,
];
export const INCLUDED_PRODUCTS = [CABIN_BAGGAGE, CHECK_IN_BAGGAGE];

export const PRESELECTION_VALUES = {
  none: 'NONE',
  yes: 'YES_SELECTED',
  no: 'NO_SELECTED',
};

export const COVER_GENIUS_PRODUCTS: number[] = [
  BANKRUPTCY_INSURANCE_COVER_GENIUS.id,
  CANCELLATION_INSURANCE_COVER_GENIUS.id,
  COMPREHENSIVE_INSURANCE_COVER_GENIUS.id,
  TRAVEL_INSURANCE_COVER_GENIUS.id,
];

export const PRICE_LOCK_PRODUCT_ID = '900';
